





















































































































































import Vue from 'vue'
import { withDefault } from '@/components/exercises/measure/filters'
import { AUTO_REFRESH_PATIENTS, PATIENT_NOUN, SHOW_LOCATION_BY_VIBE } from '@/constants/app-variables'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as PatientActionNames } from '@/store/modules/patient/keys'
import { COMMON_ICONS_BASE64, convertBase64ForSrc } from '@/utils/image-utils'
import { AppGetterNames } from '@/store/modules/app/keys'
import { currentTimestamp, ONE_DAY, ONE_MINUTE, ONE_SECOND } from '@/utils/time'
import GenericStatusCircle from '@/components/site-stats/GenericStatusCircle.vue'
import { AGT_DEBUG, GENERIC_STATUSES } from '@/utils/constants'
import moment from 'moment-timezone'
import { ItemStatus } from '@/utils/item-status'
import { getSingularOrPlural } from '@/utils/labels'
import { last } from 'ramda'

export default Vue.extend({
  components: { GenericStatusCircle },
  filters: { withDefault },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    siteStats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isStoppedRefreshing: false,
      isFetchingData: false,
      headers: [
        {
          text: 'Home Status',
          sortable: true,
          value: 'homeStatus',
          width: 40,
        },
        {
          text: 'Home',
          sortable: true,
          value: 'orgAndSite',
          width: '60%',
        },
        {
          text: 'Meters Docked Recently',
          sortable: true,
          value: 'metersStatus',
          width: 170,
        },
        {
          text: 'Agartee Connectivity Modem Status',
          sortable: true,
          value: 'gatewaysStatus',
          width: 220,
        },
        {
          text: 'Avg Strips per day',
          sortable: true,
          value: 'usagePerDay',
          width: 150, // in case of > 100% increase
        },
      ].filter(it => !!it),
      statusColorMap: {
        active: this.$vuetify.theme.themes.light.green,
        completed: this.$vuetify.theme.themes.light.lavender,
      },
      statusLabelMap: {
        active: 'IN PROGRESS',
        completed: 'COMPLETED',
      },
      page: 1,
      pageCount: 1,
      sortBy: ['orgAndSite'],
      sortDesc: [false],
    }
  },
  computed: {
    GENERIC_STATUSES() {
      return GENERIC_STATUSES
    },
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isRocheConsultant: AppGetterNames.isRocheConsultant,
      isExecUser: AppGetterNames.isExecUser,
    }),
    convertedSitesForDataTable(): any[] {
      console.log('siteStats:')
      console.log(this.siteStats)
      return this.siteStats?.map(siteStats => ({
        siteId: siteStats.siteUsageStats.siteId,
        org: siteStats.org,
        siteName: siteStats.siteName,
        orgAndSite: (siteStats.sandbox ? 'z' : 'a') || siteStats.org || '_' || siteStats.siteName,
        homeStatus: this.buildHomeStatus(siteStats.sharedDeviceStats, siteStats.gatewayStats),
        metersStatus: this.buildMetersStatus(siteStats.sharedDeviceStats), //?.map(d => this.getStatusHtmlForDevice(d)).join('\n'),
        gatewaysStatus: this.buildGwsStatus(siteStats.gatewayStats),
        sharedDeviceStats: siteStats.sharedDeviceStats,
        gateways: siteStats.siteUsageStats.gateways,
        residents: siteStats.siteUsageStats.residents,
        usagePerDay: this.getUsagePerDayObj(siteStats.siteUsageStats.glucometerReadingsRollingAvg),
        actions: [
          // {
          //   label: 'EDIT PROFILE',
          //   color: 'primary',
          //   onClick: this.onClickEditProfile(patient.id),
          // },
          // {
          //   label: 'RETURN PACKAGE',
          //   color: 'red',
          //   onClick: this.onClickRemovePackage(patient.id),
          // },
        ],
      }))
    },
    iconImage(): string {
      return convertBase64ForSrc(COMMON_ICONS_BASE64.INFO_CIRCLE)
    },
    showLoading(): Boolean {
      //combines loading states from props and data
      return this.loading || this.isFetchingData
    },
  },
  async mounted() {
    this.resumeRefreshing()
  },
  beforeDestroy(): void {
    this.stopRefreshing()
  },
  methods: {
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    // ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    async fetchData() {
      this.isFetchingData = true
      console.log('fetchData()!')
      this.isFetchingData = false
    },
    stopRefreshing() {
      this.isStoppedRefreshing = true
    },
    resumeRefreshing() {
      this.isStoppedRefreshing = false
      this.startRefreshing()
    },
    startRefreshing() {
      if (this.isStoppedRefreshing) return
      if (!AUTO_REFRESH_PATIENTS) return
      setTimeout(async () => {
        try {
          await this.fetchData()
        } catch (e) {
          console.log('error', e)
        }
        this.startRefreshing()
      }, this.refreshTime)
    },

    roundTo1DecimalPlace(value) {
      return Math.round(10 * value) / 10
    },
    toCurrency(value: number): string {
      return '$' + (Math.round(100 * value) / 100).toFixed(2)
    },

    calcAvgUsagePerDay(dataPoints, start, end): number {
      if (dataPoints === 0) {
        return 0
      }

      let days = Math.round((end - start) / ONE_DAY)

      if (days < 1 || days > 365 * 20) {
        return 0
      }
      return dataPoints / days //Math.round((10 * dataPoints) / days) / 10
    },
    inLastTenMinutes(ts) {
      if (!ts) {
        return false
      }
      return ts > currentTimestamp() - ONE_MINUTE * 10
    },
    inLastTwoHours(ts) {
      if (!ts) {
        return false
      }
      return ts > currentTimestamp() - ONE_MINUTE * 60 * 2
    },
    inLast18Hours(ts) {
      if (!ts) {
        return false
      }
      return ts > currentTimestamp() - ONE_MINUTE * 60 * 18
    },
    inLastTwoDays(ts) {
      if (!ts) {
        return false
      }
      return ts > currentTimestamp() - ONE_DAY * 2
    },
    uptimeSecondsToTimestamp(u) {
      return currentTimestamp() - u * ONE_SECOND
    },
    getStatusHtmlForDevice(d) {
      if (!d.lastConnectionTimestamp || d.lastConnectionTimestamp < currentTimestamp() - ONE_DAY) {
        return 'offline'
      } else {
        return 'online'
      }
    },
    buildMetersStatus(metersStats): ItemStatus[] {
      return (
        metersStats?.map(meter =>
          this.inLast18Hours(meter.lastConnectionTimestamp)
            ? {
                status: GENERIC_STATUSES.Good,
                label: meter.name || meter.serialNumber,
                description: null, //'Meter docked recently',
                notes: null,
              }
            : {
                status: GENERIC_STATUSES.Critical,
                label: meter.name || meter.serialNumber,
                description:
                  'Not docked for > ' +
                  (meter.lastConnectionTimestamp ? moment().diff(meter.lastConnectionTimestamp, 'days') : 30) +
                  ' days',
                notes: null,
              }
        ) || []
      )
    },
    buildGwsStatus(gwStats): ItemStatus[] {
      let self = this
      return (gwStats || []).map(function(gw) {
        let label = gw.id
        let notes: String | null
        if (!self.inLastTenMinutes(gw.lastConnectionTimestamp)) {
          let timeDesc = ''
          if (gw.lastConnectionTimestamp == null) {
            timeDesc = '> 30 days'
          } else if (!self.inLastTwoDays(gw.lastConnectionTimestamp)) {
            let days = moment().diff(gw.lastConnectionTimestamp, 'days')
            timeDesc = days + ' days'
          } else if (!self.inLastTwoHours(gw.lastConnectionTimestamp)) {
            let hours = moment().diff(gw.lastConnectionTimestamp, 'hours')
            timeDesc = hours + ' hours'
          } else {
            let mins = moment().diff(gw.lastConnectionTimestamp, 'minutes')
            timeDesc = mins + ' mins'
          }
          return {
            status: GENERIC_STATUSES.Critical,
            label: label,
            description: 'Offline for ' + timeDesc,
            notes: null, //"Modem offline. Please check if it's plugged in",
          }
        }
        if (!self.inLastTwoDays(gw.lastEthernetDeviceConnection)) {
          notes = 'GW online, but no meter docked to this BU in the last 2 days'
          // return {
          //   status: GENERIC_STATUSES.Attention,
          //   label: label,
          //   description: 'GW online, but no meter docked to this BU in the last 2 days',
          // }
        }
        if (self.inLastTenMinutes(self.uptimeSecondsToTimestamp(gw.uptimeS))) {
          notes = 'rebooted just now'
          // return {
          //   status: GENERIC_STATUSES.Attention,
          //   label: label,
          //   description: 'GW rebooted just now',
          // }
        } else if (self.inLastTenMinutes(self.uptimeSecondsToTimestamp(gw.tractorUptimeS))) {
          notes = 'Services restarted just now'
          // return {
          //   status: GENERIC_STATUSES.Attention,
          //   label: label,
          //   description: 'Services restarted just now',
          // }
        }
        // if (!gw.servicesUpToDate) {
        //   return {
        //     status: GENERIC_STATUSES.Attention,
        //     label: label,
        //     description: 'Software update available',
        //   }
        // }
        return {
          status: GENERIC_STATUSES.Good,
          label: label,
          description: null,
          notes: notes,
        }
      })
    },
    buildHomeStatus(metersStats, gwsStats): ItemStatus {
      let gwsStatus = this.buildGwsStatus(gwsStats)
      let metersStatus = this.buildMetersStatus(metersStats)
      let combined = [...gwsStatus, ...metersStatus]

      let gwsOffline = gwsStatus.filter(s => s.status === GENERIC_STATUSES.Critical)
      let metersNoData = metersStatus.filter(s => s.status === GENERIC_STATUSES.Critical)

      if (gwsOffline.length || metersNoData.length) {
        let notes = gwsOffline.length
          ? 'Please un-plug and re-plug the Agartee ' +
            getSingularOrPlural(gwsOffline.length, 'modem', 'modems') +
            ' in red (' +
            gwsOffline.length +
            ')'
          : 'Please dock the ' +
            getSingularOrPlural(metersNoData.length, 'meter', 'meters') +
            ' in red so the readings are uploaded (' +
            metersNoData.length +
            ')'
        return {
          status: GENERIC_STATUSES.Critical,
          label: '',
          description: 'One or more devices here has an issue - Data may not be uploaded until this is resolved',
          notes: notes,
        }
      }
      if (combined.some(s => s.status === GENERIC_STATUSES.Attention)) {
        return {
          status: GENERIC_STATUSES.Attention,
          label: '',
          description: 'No issues found, but there are notes about some devices. See details under meters & gateways',
          notes: null,
        }
      }
      return {
        status: GENERIC_STATUSES.Good,
        label: '',
        description: 'No issues found',
        notes: null,
      }
    },
    xLastValue(array, x) {
      if (!array || !array.length) return null
      if (array.length == 1) return array[0]
      if (array.length < x) return null
      return array[array.length - x]
    },
    diffPercent(a, b) {
      if (!a || !b) {
        return null
      }
      let diff = b - a
      return (100.0 * diff) / a
    },
    getUsagePerDayObj(arr) {
      let lastValueTimestamp = this.xLastValue(arr, 1)?.timestamp || 0
      if (lastValueTimestamp < currentTimestamp() - ONE_DAY * 7) {
        let days = Math.round((currentTimestamp() - lastValueTimestamp) / ONE_DAY)
        let daysStr
        if (days > 14) {
          daysStr = '14+'
        } else {
          daysStr = days + ''
        }
        return { value: null, changePct: 0, daysSinceLastValue: daysStr }
      }

      if (lastValueTimestamp < currentTimestamp() - ONE_DAY * 3) {
        // no readings
        return { value: 0, changePct: -100 }
      }

      return {
        value: this.roundTo1DecimalPlace(this.xLastValue(arr, 2)?.value),
        changePct: Math.round(this.diffPercent(this.xLastValue(arr, 3)?.value, this.xLastValue(arr, 2)?.value)),
      }
    },
  },
})
